import { ElMessage, ElNotification, ElMessageBox } from "element-plus";

export default {
  name: "msg",
  //复制地址的操作
  copy(value) {
    var input = document.createElement("input"); // js创建一个input输入框
    input.value = value; // 将需要复制的文本赋值到创建的input输入框中，this.ruleForm.url这个是我要复制的内容
    document.body.appendChild(input); // 将输入框暂时创建到实例里面
    input.select(); // 选中输入框中的内容
    document.execCommand("Copy"); // 执行复制操作
    document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
    ElMessage({
      type: "success",
      message: "复制成功",
      duration: 3000,
    });
  },
  success(msg, duration = 3000) {
    ElMessage({
      type: "success",
      message: msg || "操作成功",
      duration: duration,
    });
  },

  error(msg, duration = 3000) {
    ElMessage({
      type: "error",
      message: msg || "操作失败",
      duration: duration,
    });
  },

  warning(msg, duration = 3000) {
    ElMessage({
      type: "warning",
      message: msg || "警告",
      duration: duration,
    });
  },

  info(msg) {
    ElMessage(msg);
  },

  notifySuccess(data) {
    ElNotification({
      title: data.title || "成功",
      message: data.msg || "操作成功",
      type: "success",
    });
  },
  notifySuccess(msg) {
    ElNotification({
      title: "成功",
      message: msg || "操作成功",
      type: "success",
    });
  },
  notifyWarning(data) {
    ElNotification({
      title: data.title || "警告",
      message: data.msg || "",
      type: "warning",
    });
  },

  notifyWarning(msg) {
    ElNotification({
      title: "警告",
      message: msg || "",
      type: "warning",
    });
  },
  notifyInfo(data) {
    ElNotification({
      type: "info",
      title: data.title || "消息",
      message: data.msg || "",
    });
  },

  notifyInfo(msg) {
    ElNotification({
      type: "info",
      title: "消息",
      message: msg || "",
    });
  },
  notifyError(data) {
    ElNotification({
      type: "error",
      title: data.title || "消息",
      message: data.msg || "操作失败",
    });
  },
  notifyError(msg) {
    ElNotification({
      type: "error",
      title: "消息",
      message: msg || "操作失败",
    });
  },

  confirm({
    msg,
    title = "提示",
    confirmButtonText = "确定",
    cancelButtonText = "取消",
    closeOnClickModal = true,
    closeOnPressEscape = true,
    showCancelButton = true,
    type = "warning",
    confirmFn,
    cancelFn,
  }) {
    ElMessageBox.confirm(msg, title, {
      confirmButtonText,
      cancelButtonText,
      type,
      closeOnClickModal,
      closeOnPressEscape,
      showCancelButton,
      // autofocus: false
    })
      .then(() => {
        if (confirmFn) {
          confirmFn();
        }
      })
      .catch(() => {
        if (cancelFn) {
          cancelFn();
        }
      });
  },
};
